import { PayloadAction } from "@reduxjs/toolkit";
import { SportCourt } from "apis/SportCourtAPI";
import { SPORT_COURT_ACTIONS } from "store/actions/sportCourtActions";

export interface SportCourtState {
  hasSportCourts: boolean;
  sportCourts: SportCourt[];
}

const INITIAL_STATE: SportCourtState = {
  hasSportCourts: false,
  sportCourts: [],
};

type FetchSportCourtAction = PayloadAction<{ value: SportCourt[] }>;

const sportCourtReducer = (
  state: SportCourtState = INITIAL_STATE,
  action: FetchSportCourtAction
): SportCourtState => {
  switch (action.type) {
    case SPORT_COURT_ACTIONS.FETCH:
      return {
        ...state,
        hasSportCourts: true,
        sportCourts: action.payload.value,
      };
    default:
      return state;
  }
};

export default sportCourtReducer;
